import { useEffect, useState } from "react";
import { Box, FormControlLabel, Checkbox, RadioGroup, Collapse, Radio } from "@mui/material";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

export const PlacementsGroup = ({ formState, setFormState }: any) => {
    const [placementMode, setPlacementMode] = useState<"all" | "custom">(
        formState.placements ? "custom" : "all"
    );

    const [youtubeOpen, setYoutubeOpen] = useState(false);

    useEffect(() => {
        const children = ['youtube_in_streams', 'youtube_in_feeds', 'youtube_shorts'] as const;
        const anySelected = children.some(key => formState.placements?.[key]);
        setYoutubeOpen(anySelected);
    }, [formState.placements]);

    const togglePlacement = (key: any, value: boolean) => {
        setFormState((prev: any) => ({
            ...prev,
            placements: {
                ...prev.placements,
                [key]: value,
            },
        }));
    };

    return (
        <Box>
            <RadioGroup
                value={placementMode}
                onChange={(e) => {
                    const mode = e.target.value as "all" | "custom";
                    setPlacementMode(mode);

                    if (mode === "all") {
                        setFormState((prev: any) => ({
                            ...prev,
                            placements: undefined,
                        }));
                    } else {
                        setFormState((prev: any) => ({
                            ...prev,
                            placements: {
                                youtube_in_streams: false,
                                youtube_in_feeds: false,
                                youtube_shorts: false,
                                gmail: false,
                                discover: false,
                                display: false,
                            },
                        }));
                    }

                }}
                sx={{ display: "flex", flexDirection: "row" }}
            >
                <FormControlLabel value="all" control={<Radio />} label="Все Google каналы" />
                <FormControlLabel value="custom" control={<Radio />} label="Выбрать канал" />
            </RadioGroup>

            {placementMode === "custom" && (
                <div className="ml-4 mt-2">
                    {/* YouTube */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={
                                        ['youtube_in_streams', 'youtube_in_feeds', 'youtube_shorts'].some(
                                            k => formState.placements![k]
                                        )
                                    }
                                    onChange={() => {
                                        const children = ['youtube_in_streams', 'youtube_in_feeds', 'youtube_shorts'] as const;
                                        const anySelected = children.some(key => formState.placements?.[key]);
                                        children.forEach(key => togglePlacement(key, !anySelected));
                                    }}
                                />
                            }
                            sx={{ width: '100%' }}
                            label="YouTube"
                        />

                        {/* Галка справа */}
                        <span
                            style={{
                                transform: youtubeOpen ? 'rotate(90deg)' : 'rotate(270deg)',
                                transition: 'transform 0.1s',
                                cursor: 'pointer',
                            }}
                            onClick={() => setYoutubeOpen(prev => !prev)}
                        >
                            <ArrowBackIosIcon sx={{ fontSize: '11px' }} />
                        </span>
                    </div>

                    <Collapse in={youtubeOpen}>
                        <div className="ml-6 flex flex-col">
                            {(['youtube_in_streams', 'youtube_in_feeds', 'youtube_shorts'] as const).map(id => (
                                <FormControlLabel
                                    key={id}
                                    control={
                                        <Checkbox
                                            checked={formState.placements![id]}
                                            onChange={(e) => togglePlacement(id, e.target.checked)}
                                        />
                                    }
                                    label={id.replace('youtube_', '').replace('_', ' ')}
                                    sx={{ textTransform: 'capitalize' }}
                                />
                            ))}
                        </div>
                    </Collapse>

                    {/* Discover */}
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={formState.placements!.discover}
                                onChange={(e) => togglePlacement('discover', e.target.checked)}
                            />
                        }
                        label="Discover"
                    />

                    {/* Gmail */}
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={formState.placements!.gmail}
                                onChange={(e) => togglePlacement('gmail', e.target.checked)}
                            />
                        }
                        label="Gmail"
                    />

                    {/* Google Display Network */}
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={formState.placements!.display}
                                onChange={(e) => togglePlacement('display', e.target.checked)}
                            />
                        }
                        label="Google Display Network"
                    />
                </div>
            )}
        </Box>
    );
}